import React from "react";
 import { connect } from "react-redux";
import {getRevenueReports} from "../../../services/admin/action";
import moment from "moment";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Revenve from "./revenve";
import FaxedPages from "./faxedpages";
import Average from './avgpages';
import Completed from './completed'
import Practioners from './practitioner';
import Facility from './facility'

class AllReports extends React.Component {
    constructor(props) {

        super(props)
        this.state = {
            access_token: "",
            revenueRecord: true,
            faxedPage: false,
            completedRecord: false,
            avgPagesRecord: false,
            practitionerRecord: false,
            facilityRecord: false,
            startDate: "",
            endDate: "",
            state: "",
            stateList: [],
             employee: "",
            revenueReportList: [],
            faxPageList: [],
            avgReportList: [],
            completedReportList: [],
            facilityReportList: [],
            practitionerList: [],
            index: 0,
            pageOfItemsZero :[],
            pageOfItemsOne :[],
            pageOfItemsTwo :[],
            pageOfItemsThree :[],
            pageOfItemsFour :[],
            pageOfItemsFive :[],
            exportModal:false

 
        };
    }


    onChangeZero = (pageOfItems) => {
         this.setState({ pageOfItemsZero: pageOfItems });
    }
    onChangeOne = (pageOfItems) => {
            this.setState({ pageOfItemsOne: pageOfItems });
    }
    onChangeTwo = (pageOfItems) => {
        this.setState({ pageOfItemsTwo: pageOfItems });
    }
    onChangeThree = (pageOfItems) => {
        this.setState({ pageOfItemsThree: pageOfItems });
    }
    onChangeFour = (pageOfItems) => {
        this.setState({ pageOfItemsFour: pageOfItems });
    }
    onChangeFive = (pageOfItems) => {
        this.setState({ pageOfItemsFive: pageOfItems });
    }

     

 
    componentDidMount() {

        // let payload = {
        //     state: this.state.state,
        //     employeeId:this.state.employee,
        //     fromDate:this.state.startDate,
        //     toDate:this.state.endDate
        // }
         let access_token = this.props.loginDetails;
         //  this.props.getRevenueReports(access_token, payload)


        this.search();


        this.setState({
            access_token,

        })
        let date = new Date();
        // let date1 = moment(date).format('YYYY-MM-DD')

        let startDate = moment(date).format('YYYY-MM-DD HH:mm:ss')

        let endDate = moment(startDate).add(30, 'days').format('YYYY-MM-DD HH:mm:ss')
      
        this.setState({
            startDate,
            endDate,
        })
        if (this.props.getByLocationDetails) {
            let data = this.props.getByLocationDetails.stateListObj;
            this.setState({
                stateList: data
            })
        }



     }


   
    settingsNav = (e) => {
        e.preventDefault();
        let selectedItem = e.target.id;
         this.setState({
            index: selectedItem
        })
         

    }
    chageStartDate = (date) => {
        this.setState({
            startDate: date,
        })
    }
    changeEndDate = (date) => {
        this.setState({
            endDate: date,
        })
    }
    changeState = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    };
    changeEmployee = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    };
    search = () => {

        let payload = {
            state: this.state.state,
            employeeId: this.state.employee,
            fromDate: this.state.startDate,
            toDate: this.state.endDate
        }
        let completedPayload = {
            state: this.state.state,
            employeeId: this.state.employee,
            fromDate: this.state.startDate,
            toDate: this.state.endDate,
            recordStatus: "Completed",
        }

        let practitionerPayload = {
            state: this.state.state,
            fromDate: this.state.startDate,
            toDate: this.state.endDate
        }

        let token = this.props.loginDetails;


         this.props.getRevenueReports(token, payload, completedPayload, practitionerPayload );
        // this.props.getFaxedPagesApi(token, payload);
        // this.props.getAverageReports(token, payload);
        // this.props.getCompletedReports(token, completedPayload);
        // this.props.getFacilityReports(token, payload);
        // this.props.getPractitionerReports(token, practitionerPayload);



    }


    openExportModal = () =>{
        document.body.classList.add('modal-open');

        this.setState({
            exportModal : true
        })
    }

    closeExportModal = () =>{
        document.body.classList.remove('modal-open');

        this.setState({
            exportModal : false
        })
    }

    render() {

        const {
            startDate,
            endDate,
            state,
            employee,
            index,
            exportModal
        } = this.state
       
        let employeeList = []
        if (this.props.getEmployListStatus) {
             employeeList = this.props.getEmployListDetails.employeeList;
          
        }

    

        return (

            <React.Fragment>
                <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="form-group r-form">
                        <label for="dob">StartDate</label><sup>*</sup>
                        <DatePicker selected={startDate} className="form-control r-txt" id="dob"
                            type="text" placeholderText="DOB" name="dateOfBirth"
                            onChange={this.chageStartDate} peekNextMonth
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select" 
                            autocomplete="false"/>
                        <div className="r-icon">
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                   

                    <div className="form-group r-form">
                        <label for="dob">EndDate</label><sup>*</sup>
                        <DatePicker selected={endDate} className="form-control r-txt" id="dob"
                            type="text" placeholderText="DOB" name="dateOfBirth"
                            onChange={this.changeEndDate} peekNextMonth
                            minDate={this.state.startDate}   maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select" 
                            autocomplete="false"/>
                        <div className="r-icon">
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                   
                   <div className="form-group r-form">

                       <label for="state">State</label><sup>*</sup>
                       <select className="form-control" id="sel1" name="state" value={state} onChange={this.changeState}>

                           <option value="" >All States </option>
                           {this.state.stateList.length > 0 ?
                               this.state.stateList.map((state, id) => {
                                   return (
                                       <option key={id}>{state.name} </option>

                                   )
                               }) : ""

                           }

                       </select>
                   </div>
</div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">

                   <div className="form-group r-form">

                       <label for="state">Employee</label><sup>*</sup>
                       <select className="form-control" id="sel1" name="employee" value={employee} onChange={this.changeEmployee}>

                           <option value="" >All Employees </option>
                           { employeeList.length > 0 ?
                               employeeList.map((emp, id) => {
                                   return (
                                       <option key={id} value={emp.id}>{emp.firstName + "," + emp.lastName} </option>

                                   )
                               }) : ""

                           }

                       </select>
                   </div>
                   </div>

                   <div className="col-lg-12">
                   <div>
                   <button onClick={this.openExportModal} className="btn submit-btn" > Export </button>
                       <div className="form-group pull-right">
                           <button onClick={this.search} type="button" className="btnDefault right-no">Search</button>
                       </div>
                   </div>

               </div>
                </div>
               

                {this.state.exportModal &&
          <>
            <div class="modal fade in " id="editdata" role="dialog">
              <div class="modal-dialog">

                <div class="modal-content">
                <div class="modal-header">
                <h4 class="modal-title">Export</h4>
                                         <button type="button" class="close" onClick={this.closeExportModal}   >&times;</button>
                                    </div>
                  <div class="modal-body mod-body">
                    <h5 >Please click on Export button to download Xls sheet</h5>

                     <ReactHTMLTableToExcel
                                            id="test-table-xls-button"
                                            className="btn submit-btn"
                                            table="table-to-xls"
                                            filename="reports"
                                            sheet="reports"
                                            buttonText="Export" />
                  
                  </div>
                  <div class="model-btn text-center mb-3">
                    
      
                    

                    
                  </div>
                </div>



              </div>

            </div>
          </>
        }

                
               

                <div className="row">
                    <div className="col-lg-12 ">
                        <div className="inner-tab-button">
                            <ul>
                                <li onClick={this.settingsNav} id={0} className={index == 0 ? "active" : ""}>
                                    Revenue</li>

                                <li onClick={this.settingsNav} id={1} className={index == 1 ? "active" : ""}>
                                    Faxed Pages</li>

                                <li onClick={this.settingsNav} id={2} className={index == 2 ? "active" : ""}>
                                    Average Number of pages per record</li>

                                <li onClick={this.settingsNav} id={3} className={index == 3 ? "active" : ""}>
                                    Completed Record</li>

                                <li onClick={this.settingsNav} id={4} className={index == 4 ? "active" : ""}>
                                    Practitioner Record</li>

                                <li onClick={this.settingsNav} id={5} className={index == 5 ? "active" : ""}>
                                    Facility Record</li>
                            </ul>
                        </div>
                       

                        <div className="inner-tab-box table-responsive">
                            {index == 0 &&
                                <Revenve export={exportModal} />
                            }

                            {index == 1 &&
                                <FaxedPages export={exportModal} />
                            }

                            {index == 2 &&
                                <Average export={exportModal} />
                            }

                            {index == 3 &&
                                <Completed export={exportModal} />
                            }
                            {index == 4 &&
                                <Practioners export={exportModal} />
                            }
                            {index == 5 &&
                                <Facility export={exportModal} />
                            }
 
                        
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}
const mapStateToProps = state => ({
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getByLocationDetails: state.patientReducer.getByLocationDetails,

    getEmployListDetails: state.adminReducer.getEmployListDetails,
    getEmployListStatus: state.adminReducer.getEmployListStatus,

    getRevenueReportStatus: state.adminReducer.getRevenueReportStatus,
    getRevenueReportList: state.adminReducer.getRevenueReportList,

    getFaxedReportStatus: state.adminReducer.getFaxedReportStatus,
    getFaxedReportList: state.adminReducer.getFaxedReportList,

    getAverageReportStatus: state.adminReducer.getAverageReportStatus,
    getAverageReportList: state.adminReducer.getAverageReportList,

    getCompletedReportStatus: state.adminReducer.getCompletedReportStatus,
    getCompletedReportList: state.adminReducer.getCompletedReportList,

    getFacilityReportStatus: state.adminReducer.getFacilityReportStatus,
    getFacilityReportList: state.adminReducer.getFacilityReportList,

    getPractitionerReportStatus: state.adminReducer.getPractitionerReportStatus,
    getPractitionerReportList: state.adminReducer.getPractitionerReportList,

});

const mapDispatchToProps = dispatch => ({
   // getEmployeList: token => dispatch(getEmployeList(token)),
    getRevenueReports: (token, payload,  completedPayload, practitionerPayload ) => dispatch(getRevenueReports(token, payload,  completedPayload, practitionerPayload )),
    // getFaxedPagesApi: (token, payload) => dispatch(getFaxedPagesApi(token, payload)),
    // getAverageReports: (token, payload) => dispatch(getAverageReports(token, payload)),
    // getFacilityReports: (token, payload) => dispatch(getFacilityReports(token, payload)),
    // getCompletedReports: (token, payload) => dispatch(getCompletedReports(token, payload)),
    // getPractitionerReports: (token, payload) => dispatch(getPractitionerReports(token, payload)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllReports);


